import React from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem3,
    GridItem9sm12xs12,
    GridItem9,
} from '../../../business-components/Grid/Grid'

 import {
    CardGridEntradaDados,
    CardGridEntradaDadosHeaderBody,
} from '../../../business-components/Card/Card'

import {
    TextValidatorValor,
    TextValidatorNumber,
} from '../../../business-components/TextValidator/TextValidator'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    IconButtonHelp,
} from '../../../business-components/IconButton/IconButton'

import {
    processaValoresDefaultIniciaisConfiguracaoAcumulacao,
} from './EstudoServiceConfiguracaoAcumulacao'

import {
    NaoExibirOpcaoAporteUnico,
    UtilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira,
} from './EstudoCompConfiguracao'



const EstudoFormConfiguracaoAcumulacao = ( { values, handleChange, handleSubmit } ) => {

    processaValoresDefaultIniciaisConfiguracaoAcumulacao(values)

    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer
                className="justify-center"
            >
                <GridItem9sm12xs12>
                    <CardGridEntradaDados>
                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.aposentadoria}
                        >
                            <GridContainer>
                                <GridItem9>
                                    <CheckboxPadrao
                                        name="calcularAporteAtingirMetaRecursosFinanceirosInicioAposentadoria"
                                        label={LABEL.calcularAporteAtingirMetaRecursosFinanceirosInicioAposentadoria}
                                        checked={values.calcularAporteAtingirMetaRecursosFinanceirosInicioAposentadoria}
                                        onChange={handleChange}
                                    />
                                </GridItem9>
                                
                                {values.calcularAporteAtingirMetaRecursosFinanceirosInicioAposentadoria && (
                                    <GridItem3>
                                        <TextValidatorValor
                                            name="valorCalcularAporteAtingirMetaRecursosFinanceirosInicioAposentadoria"
                                            label={LABEL.valorMeta}
                                            value={
                                                values.valorCalcularAporteAtingirMetaRecursosFinanceirosInicioAposentadoria === 0
                                                    ?
                                                        0
                                                    :
                                                        values.valorCalcularAporteAtingirMetaRecursosFinanceirosInicioAposentadoria || ''
                                            }
                                            onChange={handleChange}
                                        />
                                    </GridItem3>
                                )}
                            </GridContainer>

                            <GridContainer>
                                <GridItem9>
                                    <CheckboxPadrao
                                        name="aplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria"
                                        label={LABEL.aplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria}
                                        checked={values.aplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria}
                                        onChange={handleChange}
                                    />
                                </GridItem9>
                                
                                {values.aplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria && (
                                    <>
                                        <GridItem1>
                                            <TextValidatorNumber
                                                name="percAplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria"
                                                label={LABEL.perc}
                                                value={
                                                    values.percAplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria === 0
                                                        ?
                                                            0
                                                        :
                                                            values.percAplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria || ''
                                                }
                                                onChange={handleChange}
                                                numMin={NUMMIN.percMaiorQueZero}
                                                numMax={NUMMAX.perc}
                                            />
                                        </GridItem1>
                                        <GridItem2>
                                            <IconButtonHelp
                                                helpTitle={LABEL.perc}
                                                helpText={HELPTEXT.percAplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria}
                                            />
                                        </GridItem2>
                                    </>
                                )}
                            </GridContainer>
                            
                            {/*}
                            <GridContainer>
                                <GridItem9>
                                    <CheckboxPadrao
                                        name="deduzirComplementoReceitaMensalAteAposentadoriaReservaAposentadoria"
                                        label={LABEL.deduzirComplementoReceitaMensalAteAposentadoriaReservaAposentadoria}
                                        checked={values.deduzirComplementoReceitaMensalAteAposentadoriaReservaAposentadoria}
                                        onChange={handleChange}
                                    />
                                </GridItem9>
                            </GridContainer>
                            */}
                            
                            <NaoExibirOpcaoAporteUnico
                                values={values}
                                handleChange={handleChange}
                            />
                            
                            <UtilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira
                                values={values}
                                handleChange={handleChange}
                            />

                            <GridContainer>
                                <GridItem9>
                                    <CheckboxPadrao
                                        name="naoExibirHipotesesRetornoRealAposentadoria"
                                        label={LABEL.naoExibirHipotesesRetornoRealAposentadoria}
                                        checked={values.naoExibirHipotesesRetornoRealAposentadoria}
                                        onChange={handleChange}
                                    />
                                </GridItem9>
                            </GridContainer>

                            {!values.naoExibirHipotesesRetornoRealAposentadoria && (
                                <GridContainer>
                                    <GridItem9>
                                        <CheckboxPadrao
                                            name="calcularHipotesesRetornoRealAposentadoriaViverRentabilidade"
                                            label={LABEL.calcularHipotesesRetornoRealAposentadoriaViverRentabilidade}
                                            checked={values.calcularHipotesesRetornoRealAposentadoriaViverRentabilidade}
                                            onChange={handleChange}
                                        />
                                    </GridItem9>
                                </GridContainer>
                            )}
                        </CardGridEntradaDadosHeaderBody>

                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.analisePatrimonial}
                        >
                            <GridContainer>
                                <GridItem9>
                                    <CheckboxPadrao
                                        name="exibirRecursosFinanceirosTipoRecursoFinanceiroVersusInstituicao"
                                        label={LABEL.exibirRecursosFinanceirosTipoRecursoFinanceiroVersusInstituicao}
                                        checked={values.exibirRecursosFinanceirosTipoRecursoFinanceiroVersusInstituicao}
                                        onChange={handleChange}
                                    />
                                </GridItem9>
                            </GridContainer>
                        </CardGridEntradaDadosHeaderBody>
                        
                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.projetoVidaSonho}
                        >
                            <GridContainer>
                                <GridItem9>
                                    <CheckboxPadrao
                                        name="naoCalcularAportesNecessariosRealizacaoPVS"
                                        label={LABEL.naoCalcularAportesNecessariosRealizacaoPVS}
                                        checked={values.naoCalcularAportesNecessariosRealizacaoPVS}
                                        onChange={handleChange}
                                    />
                                </GridItem9>
                            </GridContainer>

                            <GridContainer>
                                <GridItem9>
                                    <CheckboxPadrao
                                        name="naoConsiderarValorAcumulacaoJaRealizadoPVS"
                                        label={LABEL.naoConsiderarValorAcumulacaoJaRealizadoPVS}
                                        checked={values.naoConsiderarValorAcumulacaoJaRealizadoPVS}
                                        onChange={handleChange}
                                    />
                                </GridItem9>
                            </GridContainer>

                            <GridContainer>
                                <GridItem9>
                                    <CheckboxPadrao
                                        name="exibirHipotesesRetornoRealProjetoVidaSonho"
                                        label={LABEL.exibirHipotesesRetornoRealProjetoVidaSonho}
                                        checked={values.exibirHipotesesRetornoRealProjetoVidaSonho}
                                        onChange={handleChange}
                                    />
                                </GridItem9>
                            </GridContainer>

                            <GridContainer>
                                <GridItem9>
                                    <CheckboxPadrao
                                        name="naoExibirAcumulacaoAposentadoriaProjetoVidaSonho"
                                        label={LABEL.naoExibirAcumulacaoAposentadoriaProjetoVidaSonho}
                                        checked={values.naoExibirAcumulacaoAposentadoriaProjetoVidaSonho}
                                        onChange={handleChange}
                                    />
                                </GridItem9>
                            </GridContainer>
                        </CardGridEntradaDadosHeaderBody>
                    </CardGridEntradaDados>
                </GridItem9sm12xs12>
            </GridContainer>
        </ValidatorForm>
    )
}

export default EstudoFormConfiguracaoAcumulacao